<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="h3 mb-3 text-gray-800">Liberação de Benefício</h1>
    </div>
    <load mode="table" v-if="loadingBeneficios" />
    <div class="col-md-12" v-else>
      <!--Tabela-->
      <div class="row">
        <div class="col-md-12">
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div class="d-flex align-items-center justify-content-between gap-2">
                          <b-link
                            class="btn btn-default"
                            @click="$router.push('/dashboard/beneficios')"
                            v-b-tooltip.hover
                            title="Voltar para Gestão de Benefícios"
                          >
                            <i class="mdi mdi-arrow-left" />
                          </b-link>

                          <button class="btn btn-success" @click="concessaoEmLote = !concessaoEmLote" v-if="!mostrarBeneficiosSelecionados">
                            Liberação em lote
                          </button>

                          <button 
                            v-if="globalSelectedIds.length > 0"
                            class="btn btn-info ml-2" 
                            @click="mostrarBeneficiosSelecionados = !mostrarBeneficiosSelecionados"
                          >
                            {{ mostrarBeneficiosSelecionados ? 'Ocultar' : 'Visualizar' }} Selecionados
                            <span class="badge badge-light ml-1">{{ globalSelectedIds.length }}</span>
                          </button>

                          <div 
                            v-if="concessaoEmLote && !mostrarBeneficiosSelecionados"
                            class="custom-checkbox-wrapper d-flex align-items-center"
                          >
                            <b-form-checkbox
                              id="select-all-families"
                              v-model="todasAsFamilias"
                              name="select-all-families"
                              @change="selectAllFamilies"
                              :disabled="beneficiosList.length === 0"
                              class="custom-checkbox-select-all"
                            >
                              <span class="checkbox-label">
                                <i class="fas fa-users mr-2 text-primary"></i>
                                Selecionar todas as famílias
                                <span v-if="selectedRows.length > 0" class="badge badge-info ml-2">
                                  {{ selectedRows.length }}/{{ beneficiosList.length }}
                                </span>
                              </span>
                            </b-form-checkbox>
                          </div>
                        </div>

                        <b-button-group v-if="!mostrarBeneficiosSelecionados">
                          <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                          >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                          </b-button>

                          <b-button variant="outline-dark" @click="print()">
                            <i class="fas fa-print"></i>
                          </b-button>

                          <b-button
                            v-b-tooltip.hover
                            :title="$t('Exportar')"
                            variant="outline-dark"
                            @click="exportar()"
                          >
                            <i class="fas fa-file-excel"></i>
                          </b-button>
                        </b-button-group>
                      </div>
                    </div>

                    <div class="col-12" v-if="viewFilterReport && !mostrarBeneficiosSelecionados">
                      <!-- Filtros -->
                      <form @submit.prevent="getBeneficios(true)" ref="addItem">
                        <div class="row">
                          <form-select
                            v-model="filtroUnidades"
                            label="Filtrar por Unidade"
                            grid="6"
                            :itens="unidades"
                            :disabled="desabledSearchUnidade"
                            :loading="loadingSearchUnidade"
                            @input="getTecnicos()"
                            :multiple="true"
                          />

                          <form-select
                            v-model="filtroTecnicos"
                            grid="6"
                            label="Filtrar por Técnico Responsável"
                            placeholder="Selecione uma unidade antes"
                            :itens="tecnicos_selected"
                            :disabled="loadingSearchTecnicos"
                            :loading="loadingSearchTecnicos"
                            :multiple="true"
                          />

                          <form-calendar
                            v-model="data_inicio"
                            grid="6"
                            label="Data Inicial"
                          />

                          <form-calendar
                            v-model="data_fim"
                            grid="6"
                            label="Data Final"
                            :required="verificaDataInicial"
                          />

                          <!-- <form-select
                            v-model="filtroStatusParecer"
                            label="Status do Parecer"
                            :itens="$root.arrays.status_parecer"
                            grid="6"
                          /> -->

                          <form-select
                            v-model="filtroStatusConcessao"
                            label="Status da Concessão"
                            :itens="$root.arrays.status_liberacao"
                            grid="6"
                          />

                          <div class="col-md-12">
                            <label><b>Pesquisar</b></label>
                            <div class="input-group">
                              <b-input
                                placeholder="Protocolo, Tipos, Técnico e Unidade"
                                class="form-control search-input"
                                type="text"
                                v-model="search"
                                aria-describedby="input-search"
                              />
                              <div
                                class="input-group-append"
                                role="button"
                                @click.prevent="getBeneficios"
                              >
                                <span class="input-group-text" id="input-search"
                                  ><i class="fas fa-search search-icon"
                                /></span>
                              </div>
                            </div>
                            <p class="small text-muted">
                              No campo acima você pode pesquisar por: Protocolo,
                              Tipos, Técnico e Unidade
                            </p>
                          </div>
                        </div>
                        <div
                          class="row pt-4 mb-4 px-0 d-flex justify-content-end"
                        >
                          <div class="col-auto px-2 text-right">
                            <button
                              class="btn btn-default"
                              @click.prevent="
                                limparFiltros(), (viewFilterReport = false)
                              "
                            >
                              <i class="fas fa-times"></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-secondary"
                              @click.prevent="limparFiltros()"
                            >
                              {{ $t("Limpar Filtros") }}
                            </button>

                            <button
                              class="btn btn-success btn-submit"
                              data-style="zoom-in"
                              type="submit"
                            >
                              <i class="fas fa-chart-bar"></i>
                              {{ $t("Gerar Relatório") }}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div class="row" v-if="!mostrarBeneficiosSelecionados">
                    <div class="col-12">
                      <print-content>
                        <b-table
                          :fields="[
                            {
                              key: 'pessoa_familia',
                              label: $t('Detalhes'),
                            },
                            {
                              key: 'data',
                              label: $t('Data'),
                            },
                            {
                              key: 'status',
                              label: $t('Status'),
                            },
                            {
                              key: 'actions',
                              label: '',
                              class: 'text-right no-print',
                              thStyle: {
                                width: '95px',
                                minWidth: '95px',
                              },
                            },
                          ]"
                          :items="beneficiosList"
                          :responsive="true"
                          striped
                          hover
                          show-empty
                          small
                          outlined
                          stacked="md"
                          table-class="mb-3"
                          :tbody-tr-class="rowClass"
                          @row-clicked="toggleRowSelection"
                          :per-page="perPage"
                          :class="{ 'selection-mode': concessaoEmLote }"
                        >
                          <template v-slot:cell(pessoa_familia)="data">
                            <span class="d-block">
                              Benefício:
                              <b>{{ data.item.beneficio.nome }}</b
                              ><br />
                              <span v-if="data.item.quantidade > 0"
                                >Quantidade: <b>{{ data.item.quantidade }}</b
                                > - Quantidade a entregar: <b>{{ data.item.quantidade - data.item.quantidade_entregue }}</b>
                                <br />
                              </span>
                              <span v-if="data.item.periodicidade"
                                >Periodicidade:
                                <b>{{
                                  getValue(
                                    data.item.periodicidade,
                                    $root.arrays.beneficio_periodicidade
                                  )
                                }}</b></span
                              >
                            </span>
                            <span class="d-block">
                              Usuário:
                              <b>
                                {{
                                  data.item.usuario
                                    ? data.item.usuario.nome_completo
                                    : data.item.familia.responsavel_familiar
                                        .nome_completo
                                }}
                              </b>
                            </span>

                            <span>
                              <span class="d-block">
                                Unidade:
                                <b>{{
                                  data.item.responsavel.tecnico.unidade.nome
                                }}</b>
                              </span>
                              <span class="d-block">
                                Técnico:
                                <b> {{ data.item.responsavel.tecnico.nome }}</b> - <span> {{ data.item.responsavel.tecnico.profissao ?? 'Não informado' }} </span>
                              </span>
                            </span>
                          </template>

                          <template v-slot:cell(data)="data">
                            <small
                              class="text-muted d-block"
                              v-if="data.item.atualizado"
                            >
                              Criado em:{{ data.item.cadastrado }}</small
                            >
                            <small
                              class="text-muted"
                              v-if="data.item.atualizado"
                            >
                              Atualizado em:{{ data.item.atualizado }}</small
                            >
                          </template>
                          <template v-slot:cell(status)="data">
                            <span class="d-block">
                              Situação:
                              <b v-html="data.item.status_nome"></b>
                            </span>
                            <span
                              class="small text-muted"
                              v-if="
                                data.item.status_nome ==
                                  'AGUARDANDO VISITA TÉCNICA' ||
                                data.item.status_parecer == 4
                              "
                              >VISITA TÉCNICA REALIZADA</span
                            >
                            <span v-else>
                              Parecer:
                              <span
                                v-html="data.item.status_parecer_nome"
                              ></span>
                            </span>
                          </template>
                          <template v-slot:cell()="data">
                            <div v-if="!selectedRowIds.includes(data.item.id)">
                              <button
                                @click="
                                  redirectBeneficio(
                                    data.item.id,
                                    data.item.familia_id
                                  )
                                "
                                class="px-2 mb-0 btn btn-sm btn-success my-1 d-flex justify-content-start"
                                v-b-popover.hover.top="'Editar Benefício'"
                              >
                                <i class="mdi mdi-square-edit-outline" />
                              </button>
                              <button
                                class="px-2 mb-0 btn btn-sm btn-info my-1 d-flex justify-content-start"
                                v-b-popover.hover.top="'Entregar Benefício'"
                                @click="
                                  $bvModal.show('entrega-beneficio');
                                  beneficio = data.item;
                                  status_anterior = data.item.status_liberacao;
                                  is_entregue = true;
                                "
                                v-if="!data.item.is_entrega == 1"
                              >
                                <i class="mdi mdi-check" />
                              </button>
                              <button
                                class="px-2 mb-0 btn btn-sm btn-danger my-1 d-flex justify-content-start"
                                v-b-popover.hover.top="
                                  'Informar que o Benefício não foi entregue'
                                "
                                @click="
                                  $bvModal.show('entrega-beneficio');
                                  beneficio = data.item;
                                  status_anterior = data.item.status_liberacao;
                                  is_entregue = false;
                                "
                                v-if="!data.item.is_entrega == 1"
                              >
                                <i class="mdi mdi-close" />
                              </button>
                            </div>
                          </template>
                          <template v-slot:empty="scope">
                            <div class="text-center my-5">
                              <img
                                :alt="$t('No results')"
                                class="mb-5"
                                src="/img/icons/robot.svg"
                                style="max-height: 165px"
                              />
                              <h3 class="bold">
                                {{ $t("No records found") }}
                              </h3>
                            </div>
                          </template>
                        </b-table>
                      </print-content>
                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getBeneficios"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>

                        <div class="box-btn-print no-print">
                          <b-button
                            v-if="!loadingBeneficios"
                            :title="$t('Visualizar e Imprimir')"
                            class="py-2"
                            size="sm"
                            type="button"
                            v-b-tooltip.hover
                            variant="primary"
                            @click="print()"
                          >
                            <i class="fas fa-print"></i>
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Tabela de Benefícios Selecionados - Mover para um componente separado -->
                   <div v-if="mostrarBeneficiosSelecionados && beneficiosSelecionados.length > 0" >
                    <form @submit.prevent="processarLiberacaoEmLote">
                      <div class="row">
                        <form-calendar
                          v-model="data_entrega"
                          label="Data prevista da entrega"
                          grid="4"
                        />
                        <form-select
                          v-model="local"
                          label="Local entrega"
                          :itens="itensLocalEntrega"
                          :required="true"
                          grid="6"
                        />
                      </div>
                      <div class="row mb-4">
                        <div class="col-12">
                          <div class="card border-info">
                            <div class="card-header bg-info text-white">
                              <h5 class="mb-0">
                                <i class="fas fa-list-ul mr-2"></i>
                                Benefícios Selecionados para Liberação ({{ beneficiosSelecionados.length }})
                              </h5>
                            </div>
                            <div class="card-body">
                              <div v-if="beneficiosSelecionados.length === 0" class="text-center py-4">
                                <i class="fas fa-info-circle text-muted mb-2" style="font-size: 2rem;"></i>
                                <p class="text-muted mb-0">Nenhum benefício selecionado</p>
                              </div>
                              <div v-else>
                                <print-content>
                                  <b-table
                                    :fields="[
                                      { key: 'beneficio_info', label: 'Benefício', thClass: 'text-left' },
                                      { key: 'usuario_info', label: 'Usuário', thClass: 'text-left' },
                                      { key: 'tecnico_info', label: 'Técnico/Unidade', thClass: 'text-left' },
                                      { key: 'status_info', label: 'Status', thClass: 'text-left' },
                                      { key: 'actions', label: 'Ações', class: 'text-center no-print', thClass: 'text-center' }
                                    ]"
                                    :items="beneficiosSelecionados"
                                    :responsive="true"
                                    striped
                                    hover
                                    show-empty
                                    small
                                    outlined
                                    table-class="mb-0"
                                  >
                                    <template v-slot:cell(beneficio_info)="data">
                                      <div>
                                        <strong class="text-primary">{{ data.item.beneficio.nome }}</strong>
                                        <div class="small text-muted">
                                          <span v-if="data.item.quantidade > 0">
                                            <i class="fas fa-hashtag mr-1"></i>Qtd Total: {{ data.item.quantidade }}
                                          </span>
                                          <span v-if="data.item.periodicidade" class="ml-2">
                                            <i class="fas fa-clock mr-1"></i>
                                            {{ getValue(data.item.periodicidade, $root.arrays.beneficio_periodicidade) }}
                                          </span>
                                        </div>
                                        <div v-if="data.item.quantidade > 0" class="mt-2">
                                          <label class="small font-weight-bold text-primary">Quantidade a entregar:</label>
                                          <b-form-input
                                            v-model.number="data.item.quantidade_entrega"
                                            type="number"
                                            :min="1"
                                            :max="data.item.quantidade - (data.item.quantidade_entregue || 0)"
                                            size="sm"
                                            class="mt-1"
                                            @input="atualizarQuantidadeEntrega(data.item.id, $event)"
                                            placeholder="Digite a quantidade"
                                          ></b-form-input>
                                          <small class="text-muted">Máximo: {{ data.item.quantidade - (data.item.quantidade_entregue || 0) }}</small>
                                        </div>
                                      </div>
                                    </template>

                                    <template v-slot:cell(usuario_info)="data">
                                      <div>
                                        <strong>
                                          {{ data.item.usuario 
                                            ? data.item.usuario.nome_completo 
                                            : data.item.familia.responsavel_familiar.nome_completo 
                                          }}
                                        </strong>
                                        <div class="small text-muted">
                                          <i class="fas fa-user mr-1"></i>
                                          {{ data.item.usuario ? 'Usuário' : 'Responsável Familiar' }}
                                        </div>
                                      </div>
                                    </template>

                                    <template v-slot:cell(tecnico_info)="data">
                                      <div>
                                        <strong>{{ data.item.responsavel.tecnico.nome }}</strong>
                                        <div class="small text-muted">
                                          <i class="fas fa-user-tie mr-1"></i>
                                          {{ data.item.responsavel.tecnico.profissao ?? 'Não informado' }}
                                        </div>
                                        <div class="small text-muted">
                                          <i class="fas fa-building mr-1"></i>
                                          {{ data.item.responsavel.tecnico.unidade.nome }}
                                        </div>
                                      </div>
                                    </template>

                                    <template v-slot:cell(status_info)="data">
                                      <div>
                                        <span class="badge" v-html="data.item.status_nome"></span>
                                        <div class="small text-muted mt-1">
                                          <span v-if="data.item.status_nome == 'AGUARDANDO VISITA TÉCNICA' || data.item.status_parecer == 4">
                                            <i class="fas fa-check-circle text-success mr-1"></i>
                                            VISITA TÉCNICA REALIZADA
                                          </span>
                                          <span v-else>
                                            <i class="fas fa-clipboard-check mr-1"></i>
                                            Parecer: <span v-html="data.item.status_parecer_nome"></span>
                                          </span>
                                        </div>
                                      </div>
                                    </template>

                                    <template v-slot:cell(actions)="data" class="no-print">
                                      <b-button
                                        size="sm"
                                        variant="outline-danger"
                                        @click="removerBeneficioSelecionado(data.item.id)"
                                        v-b-tooltip.hover
                                        title="Remover da seleção"
                                      >
                                        <i class="fas fa-times"></i>
                                      </b-button>
                                    </template>
                                  </b-table>
                                </print-content>
                                
                                <div class="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                                  <div class="text-muted">
                                    <i class="fas fa-info-circle mr-1"></i>
                                    Total de benefícios selecionados: <strong>{{ beneficiosSelecionados.length }}</strong>
                                  </div>
                                  <div>
                                    <b-button
                                      variant="outline-secondary"
                                      size="sm"
                                      @click="limparBeneficiosSelecionados"
                                      class="mr-2"
                                    >
                                      <i class="fas fa-times mr-1"></i>
                                      Limpar Seleção
                                    </b-button>
                                    <b-button
                                      variant="success"
                                      size="sm"
                                      type="submit"
                                      :disabled="beneficiosSelecionados.length === 0"
                                    >
                                      <i class="fas fa-check mr-1"></i>
                                      Concluir concessão em lote
                                    </b-button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="box-btn-print no-print">
                    <b-button
                      :title="$t('Visualizar e Imprimir')"
                      class="py-2"
                      size="sm"
                      type="button"
                      v-b-tooltip.hover
                      variant="primary"
                      @click="print()"
                    >
                      <i class="fas fa-print"></i>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalEntrega
      :beneficio="beneficio"
      :isEntregue="is_entregue"
      :statusAnterior="status_anterior"
      @submit="getBeneficios"
    />
  </div>
</template>
<style scoped>
.table-info {
  background-color: #d1ecf1 !important;
  cursor: pointer;
}

.table tbody tr {
  cursor: pointer;
}

.table tbody tr:hover {
  cursor: pointer;
}

.table tbody tr.table-info:hover {
  background-color: #bee5eb !important;
}

/* Estilos customizados para o checkbox */
.custom-checkbox-wrapper {
  margin-left: 8px;
  padding: 8px 12px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.custom-checkbox-wrapper:hover {
  background-color: #e9ecef;
  border-color: #dee2e6;
}

.custom-checkbox-select-all {
  margin-bottom: 0 !important;
}

.custom-checkbox-select-all .custom-control-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
}

.custom-checkbox-select-all .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #28a745;
  border-color: #28a745;
}

.custom-checkbox-select-all .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(40, 167, 69, 0.25);
}

.custom-checkbox-select-all .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
  opacity: 0.6;
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1.4;
}

.checkbox-label .badge {
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 12px;
}

/* Responsividade */
@media (max-width: 768px) {
  .custom-checkbox-wrapper {
    margin-left: 0;
    margin-top: 8px;
    width: 100%;
  }
  
  .checkbox-label {
    font-size: 13px;
  }
}
</style>
<script>
import ModalEntrega from "../ModalEntregaGeral";
export default {
  components: { ModalEntrega },
  name: "beneficios",
  metaInfo() {
    return {};
  },
  data() {
    return {
      familia: {},
      beneficio: "",
      is_entregue: false,
      status_anterior: false,
      TipobeneficiosList: [],
      beneficiosList: [],
      data_entrega: null,
      page: 1,
      search: "",
      perPage: 10,
      loadingBeneficios: true,
      loading: true,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      isGestor: true,
      loadingSearchUnidade: true,
      desabledSearchUnidade: true,
      loadingSearchTecnicos: true,
      filtroUnidades: [],
      filtroTecnicos: [],
      filtroStatusConcessao: null,
      filtroStatusParecer: null,
      filtroDatas: [],
      tecnicos_selected: [],
      todasAsFamilias: false,
      concessaoEmLote: false,
      mostrarBeneficiosSelecionados: false,
      selectedRows: [],
      selectedRowIds: [],
      globalSelectedIds: [],
      allSelectedBeneficios: [],
      locaisEntregaPorMunicipio: {
        default: [
          { id: 'NA UNIDADE', value: 'NA UNIDADE' },
          { id: 'NA RESIDÊNCIA', value: 'NA RESIDÊNCIA' }
        ],
        caraguatatuba: [
          { id: "CIASC PONTE SECA", value: "CIASC PONTE SECA" },
          { id: "CIASC PEREQUÊ MIRIM", value: "CIASC PEREQUÊ MIRIM" },
          { id: "BANCO DE ALIMENTOS", value: "BANCO DE ALIMENTOS" },
          { id: "NÚCLEO JOÃO BOLINHA", value: "NÚCLEO JOÃO BOLINHA" },
          { id: "NÚCLEO ALTO DO JETUBA", value: "NÚCLEO ALTO DO JETUBA" },
          { id: "NÚCLEO PEDRA GRANDE", value: "NÚCLEO PEDRA GRANDE" },
        ],
      }
    };
  },
  mounted() {
    this.getBeneficios();
    this.getTecnicos();
    this.getUnidades();
    this.buscarMunicipio();
  },
  computed: {
    listtecnicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      return map;
    },
    beneficiosSelecionados() {
      return this.allSelectedBeneficios;
    },
    itensLocalEntrega() {
      const municipio = this.municipio.trim().toLowerCase();

      if (municipio == "caraguatatuba"){ return this.locaisEntregaPorMunicipio[municipio]; }
        
      return this.locaisEntregaPorMunicipio.default;
    }
  },
  updated() {
    let role_user = this.$store.state.user.role_details.name;
    this.isGestor =
      this.$store.state.user.permissions["BeneficioController"] == true ||
      role_user == "Admin"
        ? true
        : false;
    if (this.isGestor == false) {
      this.redirectBeneficioIndex();
    }
  },
  watch: {
    beneficiosList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.updateCheckboxState();
        }
      },
      deep: true,
    },
    concessaoEmLote: {
      handler(newVal) {
        if (newVal) {
          this.selectAllByDefault();
        } else {
          this.clearSelection();
        }
      },
    },
  },
  methods: {
    async buscarMunicipio() {
      this.municipio = this.$store.state.municipio.toLowerCase();
    },
    getValue(value, array) {
      const result = array.filter((item) => item.id == value);
      return result[0] ? result[0].value : "";
    },
    selectTecicos() {
      const pessoas = this.tecnicos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      this.tecnicos_selected = map;
    },
    getBeneficios(resetPage = false) {
      if (resetPage) {
        this.page = 1;
      }

      this.loadingBeneficios = true;

      this.filtroDatas = [];

      if (this.data_inicio) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_inicio)
        );
      }

      if (this.data_fim) {
        this.filtroDatas = this.filtroDatas.concat(
          this.$options.filters.formatDateYMD(this.data_fim)
        );
      }

      axios
        .get("api/dashboard/beneficios/liberacao", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatusParecer: this.filtroStatusParecer,
            filtroStatusConcessao: this.filtroStatusConcessao,
            filtroDatas: this.filtroDatas,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
          },
        })
        .then((response) => {
          this.beneficiosList = response.data.data;
          this.pagination = response.data.pagination;
          this.loadingBeneficios = false;
          this.syncSelectionWithGlobal();
        })
        .catch(() => {
          this.loadingBeneficios = false;
        });
    },
    exportar() {
      this.isLoadingMsg = true;
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get("api/dashboard/beneficios/liberacao", {
          params: {
            page: this.page,
            search: this.search,
            perPage: this.perPage,
            filtroStatusParecer: this.filtroStatusParecer,
            filtroStatusConcessao: this.filtroStatusConcessao,
            filtroDatas: this.filtroDatas,
            filtroUnidades: this.filtroUnidades,
            filtroTecnicos: this.filtroTecnicos,
            export: "ok",
          },
        })
        .then((response) => {
          this.isLoadingMsg = false;
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          (this.isLoadingMsg = false), (this.loading = false);
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getBeneficios();
      }
    },
    redirectBeneficio(id, familia_id) {
      this.$router.push({
        path: `/dashboard/familia/beneficio/edit/${id}`,
        query: { familia_id: familia_id },
      });
    },
    redirectBeneficioIndex() {
      this.$router.push({
        path: `/dashboard/beneficios`,
      });
    },

    getUnidades() {
      this.loadingSearchUnidade = true;
      this.desabledSearchUnidade = true;
      axios
        .get(`api/dashboard/unidades/get/externas`)
        .then((response) => {
          this.unidades = response.data;
        })
        .finally(() => {
          this.loadingSearchUnidade = false;
          this.desabledSearchUnidade = false;
        });
    },
    getTecnicos() {
      this.tecnicos = [];
      this.loadingSearchTecnicos = true;
      axios
        .get(`api/dashboard/atendimento/tecnicos/get`, {
          params: {
            unidades: this.filtroUnidades,
          },
        })
        .then((response) => {
          this.tecnicos = response.data;
          this.selectTecicos();
        })
        .finally(() => (this.loadingSearchTecnicos = false));
    },

    limparFiltros() {
      this.filtroUnidades = [];
      this.filtroTecnicos = [];
      this.filtroStatusConcessao = null;
      this.filtroStatusParecer = null;
      this.data_inicio = null;
      this.data_fim = null;
      this.search = "";
      this.page = 1;

      this.getBeneficios();
    },

    rowClass(item, type) {
      if (!item || type !== "row") return "";

      if (this.selectedRowIds.includes(item.id)) {
        return "table-info";
      }

      return "";
    },

    toggleRowSelection(item) {

      const index = this.selectedRowIds.indexOf(item.id);
      const globalIndex = this.globalSelectedIds.indexOf(item.id);

      if (index > -1) {
        this.selectedRowIds.splice(index, 1);
        this.selectedRows = this.selectedRows.filter((row) => row.id !== item.id);

        if (globalIndex > -1) {
          this.globalSelectedIds.splice(globalIndex, 1);
        }

        // Remover do array de todos os benefícios selecionados
        this.allSelectedBeneficios = this.allSelectedBeneficios.filter(beneficio => beneficio.id !== item.id);
      } else {
        // Inicializar quantidade_entrega se o benefício tem quantidade
        if (item.quantidade > 0) {
          const quantidadeRestante = item.quantidade - (item.quantidade_entregue || 0);
          item.quantidade_entrega = quantidadeRestante > 0 ? quantidadeRestante : item.quantidade;
        }
        
        this.selectedRowIds.push(item.id);
        this.selectedRows.push(item);

        if (globalIndex === -1) {
          this.globalSelectedIds.push(item.id);
        }

        // Adicionar ao array de todos os benefícios selecionados (evitar duplicatas)
        const existeNoArray = this.allSelectedBeneficios.find(beneficio => beneficio.id === item.id);
        if (!existeNoArray) {
          this.allSelectedBeneficios.push(item);
        }
      }
      
      this.updateCheckboxState();
    },

    clearSelection() {
      this.selectedRows = [];
      this.selectedRowIds = [];
      this.todasAsFamilias = false;
      this.globalSelectedIds = [];
      this.allSelectedBeneficios = [];
      this.mostrarBeneficiosSelecionados = false;
    },

    selectAllByDefault() {
      if (this.concessaoEmLote && this.beneficiosList.length > 0) {
        this.selectedRows = [...this.beneficiosList];
        this.selectedRowIds = this.beneficiosList.map((item) => item.id);
        this.globalSelectedIds = this.beneficiosList.map((item) => item.id);

        // Adicionar todos os benefícios ao array global
        this.allSelectedBeneficios = [...this.beneficiosList];

        this.todasAsFamilias = true;
      }
    },

    selectAllFamilies() {
      if (this.todasAsFamilias) {
        this.selectedRows = [...this.beneficiosList];
        this.selectedRowIds = this.beneficiosList.map((item) => item.id);

        this.beneficiosList.forEach(item => {
          if (!this.globalSelectedIds.includes(item.id)) {
            this.globalSelectedIds.push(item.id);
          }
          
          // Inicializar quantidade_entrega se o benefício tem quantidade
          if (item.quantidade > 0) {
            const quantidadeRestante = item.quantidade - (item.quantidade_entregue || 0);
            item.quantidade_entrega = quantidadeRestante > 0 ? quantidadeRestante : item.quantidade;
          }
          
          // Adicionar ao array global se não existir
          const existeNoArray = this.allSelectedBeneficios.find(beneficio => beneficio.id === item.id);
          if (!existeNoArray) {
            this.allSelectedBeneficios.push(item);
          }
        });
      } else {
        const currentPageIds = this.beneficiosList.map(item => item.id);
        this.globalSelectedIds = this.globalSelectedIds.filter(id => 
          !currentPageIds.includes(id)
        );
        
        // Remover benefícios da página atual do array global
        this.allSelectedBeneficios = this.allSelectedBeneficios.filter(beneficio => 
          !currentPageIds.includes(beneficio.id)
        );
        
        this.selectedRows = [];
        this.selectedRowIds = [];
        this.todasAsFamilias = false;
      }
    },

    updateCheckboxState() {
      this.todasAsFamilias = this.selectedRows.length === this.beneficiosList.length && this.beneficiosList.length > 0;
    },

    syncSelectionWithGlobal() {
      if (this.concessaoEmLote && this.beneficiosList.length > 0) {
        // Filtrar apenas os IDs que existem na página atual
        const currentPageIds = this.beneficiosList.map(item => item.id);
        const selectedInCurrentPage = this.globalSelectedIds.filter(id => 
          currentPageIds.includes(id)
        );
        
        // Atualizar seleção da página atual
        this.selectedRowIds = selectedInCurrentPage;
        this.selectedRows = this.beneficiosList.filter(item => 
          selectedInCurrentPage.includes(item.id)
        );
        
        // Sincronizar com o array global - adicionar novos benefícios da página atual que estão selecionados
        this.beneficiosList.forEach(item => {
          if (this.globalSelectedIds.includes(item.id)) {
            const existeNoArray = this.allSelectedBeneficios.find(beneficio => beneficio.id === item.id);
            if (!existeNoArray) {
              // Inicializar quantidade_entrega se o benefício tem quantidade
              if (item.quantidade > 0) {
                const quantidadeRestante = item.quantidade - (item.quantidade_entregue || 0);
                item.quantidade_entrega = quantidadeRestante > 0 ? quantidadeRestante : item.quantidade;
              }
              this.allSelectedBeneficios.push(item);
            }
          }
        });
        
        this.updateCheckboxState();
      }
    },

    atualizarQuantidadeEntrega(beneficioId, quantidade) {
      // Atualizar no array de benefícios selecionados
      const beneficio = this.allSelectedBeneficios.find(b => b.id === beneficioId);
      if (beneficio) {
        beneficio.quantidade_entrega = quantidade;
      }
      
      // Atualizar na lista atual se existir
      const beneficioAtual = this.beneficiosList.find(b => b.id === beneficioId);
      if (beneficioAtual) {
        beneficioAtual.quantidade_entrega = quantidade;
      }
    },

    removerBeneficioSelecionado(id) {
      // Remover da seleção global
      const globalIndex = this.globalSelectedIds.indexOf(id);
      if (globalIndex > -1) {
        this.globalSelectedIds.splice(globalIndex, 1);
      }

      // Remover da seleção da página atual se existir
      const currentIndex = this.selectedRowIds.indexOf(id);
      if (currentIndex > -1) {
        this.selectedRowIds.splice(currentIndex, 1);
        this.selectedRows = this.selectedRows.filter(row => row.id !== id);
      }

      // Remover do array de todos os benefícios selecionados
      this.allSelectedBeneficios = this.allSelectedBeneficios.filter(beneficio => beneficio.id !== id);

      if (this.allSelectedBeneficios.length === 0) {
        this.mostrarBeneficiosSelecionados = false;
      }

      this.updateCheckboxState();
    },

    limparBeneficiosSelecionados() {
      this.clearSelection();
      this.mostrarBeneficiosSelecionados = false;
    },

    processarLiberacaoEmLote() {
      if (this.globalSelectedIds.length === 0) {
        this.$bvToast.toast('Nenhum benefício selecionado', {
          title: 'Atenção',
          variant: 'warning',
          solid: true
        });
        return;
      }

      // Validar quantidades de entrega
      const beneficiosComQuantidade = this.allSelectedBeneficios.filter(b => b.quantidade > 0);
      const quantidadesInvalidas = beneficiosComQuantidade.filter(b => 
        !b.quantidade_entrega || 
        b.quantidade_entrega <= 0 || 
        b.quantidade_entrega > b.quantidade
      );

      if (quantidadesInvalidas.length > 0) {
        this.$bvToast.toast('Verifique as quantidades de entrega. Alguns benefícios possuem quantidades inválidas.', {
          title: 'Quantidades Inválidas',
          variant: 'warning',
          solid: true
        });
        return;
      }

      this.$bvModal.msgBoxConfirm(
        `Deseja realmente processar a liberação de ${this.globalSelectedIds.length} benefício(s)?`,
        {
          title: 'Confirmar Liberação em Lote',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Sim',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
      .then(value => {
        if (value) {
          this.executarLiberacaoEmLote();
        }
      });
    },

    executarLiberacaoEmLote() {
      const loadingToast = this.$bvToast.toast('Processando liberação em lote...', {
        title: 'Aguarde',
        variant: 'info',
        solid: true,
        noAutoHide: true
      });

      // Preparar dados com quantidades específicas
      const beneficiosParaEntrega = this.allSelectedBeneficios.map(beneficio => ({
        id: beneficio.id,
        quantidade_entrega: beneficio.quantidade_entrega || beneficio.quantidade || null
      }));

      axios.post('api/dashboard/beneficios/entrega/lote', {
        beneficios: beneficiosParaEntrega,
        data_entrega: this.data_entrega,
        local: this.local
      })
      .then(response => {
        this.$bvToast.toast('Liberação em lote concluída com sucesso!', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        });
        this.getBeneficios();
        this.clearSelection();
      })
      .catch(error => {
        console.error('Erro ao processar liberação em lote:', error);
        this.$bvToast.toast('Erro ao processar liberação em lote. Tente novamente.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        });
      })
      .finally(() => {
        this.data_entrega = null;
        this.$bvToast.hide(loadingToast);
      });
    },
  },
};
</script>
